import { render, staticRenderFns } from "./single.vue?vue&type=template&id=25c9ff14&scoped=true&"
import script from "./single.vue?vue&type=script&lang=js&"
export * from "./single.vue?vue&type=script&lang=js&"
import style0 from "./single.vue?vue&type=style&index=0&id=25c9ff14&prod&lang=less&scoped=true&"
import style1 from "./single.vue?vue&type=style&index=1&id=25c9ff14&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c9ff14",
  null
  
)

export default component.exports